import { render, staticRenderFns } from "./LawMatterCourtExpertForm.vue?vue&type=template&id=94e5a3ca&"
import script from "./LawMatterCourtExpertForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterCourtExpertForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterCourtExpertForm.vue?vue&type=style&index=0&id=94e5a3ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports